// 스킬 해금 판정(D1e, docs/SKILL-TREE.md 11.1): 영웅 레벨 → 습득한 스킬 비트마스크. 비트 i = 스킬 i+1(Btn.Skill1..12 순서).
// 순수 함수·할당 없음. 정본 표는 types.ts의 SKILL_AUTO_LEARN(카엘)·HERO_SKILL_TABLE(영웅별, c022)이고, growthMods·HUD·슬롯이 모두 여기를 읽는다.
// hero를 생략하면 카엘(기존 호출 그대로).
import { HERO_SKILL_TABLE, type SkillHeroId } from './types';

/** 스킬 번호(1..12)의 비트 */
export const skillBit = (id: number): number => 1 << (id - 1);

/** 그 레벨까지 자동으로 가진 스킬: 무료 3 + 자동 습득. 트리 랭크는 보지 않는다 */
export function skillsUnlockedAt(level: number, hero: SkillHeroId = 'kael'): number {
  const t = HERO_SKILL_TABLE[hero] ?? HERO_SKILL_TABLE.kael, rows = t.autoLearn;
  let m = t.freeMask;
  for (let i = 0; i < rows.length; i++) if (level >= rows[i].level) m |= skillBit(rows[i].id);
  return m;
}

/** before → after 레벨로 오르며 새로 열린 스킬 마스크(레벨업 알림용) */
export function skillsLearnedBetween(before: number, after: number, hero: SkillHeroId = 'kael'): number {
  return skillsUnlockedAt(after, hero) & ~skillsUnlockedAt(before, hero);
}

/** 다음 자동 습득 레벨(level보다 큰 것 중 가장 낮은 것). 더 없으면 0 */
export function nextSkillLevel(level: number, hero: SkillHeroId = 'kael'): number {
  const rows = (HERO_SKILL_TABLE[hero] ?? HERO_SKILL_TABLE.kael).autoLearn;
  let best = 0;
  for (let i = 0; i < rows.length; i++) {
    const l = rows[i].level;
    if (l > level && (best === 0 || l < best)) best = l;
  }
  return best;
}
